import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_commentGray.css';

export interface WithTypeCommentGrayProps {
    type?: 'commentGray';
}

export const withTypeCommentGray = withBemMod<WithTypeCommentGrayProps>(
    'Icon',
    { type: 'commentGray' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);

export default withTypeCommentGray;
